/* eslint-disable max-len, react/no-unescaped-entities */
import React, { Component } from 'react';
import styled from 'styled-components';
import i18n from '../../config/i18n';

const H1 = styled.h1`
  color: #3C4F62;
  font-weight: 500;
  font-size: 3.2em;
  text-align: center;
  margin-top: 70px;
`;

const UpdatedText = styled.p`
  color: #B5C7D9;
  text-align: center;
  margin-top: 30px;
  margin-bottom: 60px;
`;

const P = styled.p`
  color: #73767c;
  line-height: 1.7;
  font-size: 16px;
  font-family: "Open Sans", Arial, sans-serif;
  text-align: justify;
`;

class ProductIntro extends Component {
  render() {
    return (
      <div className="ProductIntro" style={{ paddingBottom: 100 }}>
        <H1>{i18n.t('productIntroTitle')}</H1>
        <UpdatedText>{i18n.t('productIntroUpdateDate')}</UpdatedText>

        <P>
          {i18n.t('productIntroDetails_p1')}
        </P>
        <P>
          <b>{i18n.t('iHealthCareClouds')}</b>
          {i18n.t('productIntroDetails_p2')}
        </P>
        <P>
          <b>{i18n.t('iHealthCareClouds')}</b>
          {i18n.t('productIntroDetails_p3')}
        </P>
        <ul>
          <li>
            {i18n.t('productIntroDetails_p3_1')}
          </li>
          <li>
            {i18n.t('productIntroDetails_p3_2')}
          </li>
          <li>
            {i18n.t('productIntroDetails_p3_3')}
          </li>
          <li>
            {i18n.t('productIntroDetails_p3_4')}
          </li>
          <li>
            {i18n.t('productIntroDetails_p3_5')}
          </li>
          <li>
            {i18n.t('productIntroDetails_p3_6')}
          </li>
          <li>
            {i18n.t('productIntroDetails_p3_7')}
          </li>
          <li>
            {i18n.t('productIntroDetails_p3_8')}
          </li>
          <li>
            {i18n.t('productIntroDetails_p3_9')}
          </li>
          <li>
            {i18n.t('productIntroDetails_p3_10')}
          </li>
          <li>
            {i18n.t('productIntroDetails_p3_11')}
          </li>
          <li>
            {i18n.t('productIntroDetails_p3_12')}
          </li>
        </ul>
        <P>
          {i18n.t('productIntroDetails_p4')}
        </P>
      </div>
    );
  }
}

export default ProductIntro;



// WEBPACK FOOTER //
// ./src/components/static/ProductIntro.js